import { Controller } from "@hotwired/stimulus"

// FD-333: CSP-safe replacement for inline onchange="this.form.requestSubmit()".
// A strict script-src forbids inline event-handler attributes, so property-edit
// selects/inputs opt into auto-submit declaratively instead:
//   data-controller="auto-submit" data-action="change->auto-submit#submit"
export default class extends Controller {
  submit() {
    (this.element.form || this.element.closest("form"))?.requestSubmit()
  }

  // FD-426: debounced variant for live filter inputs — submits ~250ms after the
  // last keystroke so typing doesn't fire a request per character.
  debounced() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.submit(), 250)
  }
}
